import '../../../modules/es.function.bind.js';
import { g as getBuiltInPrototypeMethod$1 } from '../../../internals/get-built-in-prototype-method.js';

var getBuiltInPrototypeMethod = getBuiltInPrototypeMethod$1;

var bind = getBuiltInPrototypeMethod('Function', 'bind');

export { bind as b };
//# sourceMappingURL=bind.js.map
